<div class="flex flex-col gap-8">
  <div class="flex flex-col gap-1">
    <label
      [for]="fieldId"
      class="text-[var(--colors-gray-scale-black)] text-base font-semibold leading-6"
    >{{ TRANSLATION_KEYS.admin.calibrationTalentMatrix.hrComment.TITLE | translate }}</label>
    <span class="text-sm leading-5 text-[var(--colors-gray-scale-gray-1)]">
      {{ TRANSLATION_KEYS.admin.calibrationTalentMatrix.hrComment.DESCRIPTION | translate }}
    </span>
  </div>

  <ng-container *ngIf="loading; else commentContent">
    <div class="h-24 w-full rounded-lg bg-[var(--colors-gray-scale-light-gray)] animate-pulse"></div>
  </ng-container>

  <ng-template #commentContent>
    <!-- Commento modificabile: campo con Annulla e Salva -->
    <ng-container *ngIf="canEdit; else readOnlyComment">
      <textarea
        [id]="fieldId"
        [ngModel]="draft"
        (ngModelChange)="onDraftChange($event)"
        [placeholder]="TRANSLATION_KEYS.admin.calibrationTalentMatrix.hrComment.PLACEHOLDER | translate"
        [disabled]="saving"
        rows="4"
        class="w-full min-h-[8rem] px-3 py-3 rounded-md border border-[var(--colors-gray-scale-gray-3)] bg-white text-sm leading-5 text-[var(--colors-gray-scale-black)] resize-y placeholder:text-gray-3"
      ></textarea>
      <div class="flex flex-row gap-2">
        <!-- Il tooltip sta sul contenitore: un pulsante disabilitato non riceve gli eventi del mouse -->
        <span
          [pTooltip]="!hasChanges ? (TRANSLATION_KEYS.admin.calibrationTalentMatrix.hrComment.NO_CHANGES_TO_CANCEL | translate) : ''"
          tooltipPosition="top"
        >
          <ape-button
            variant="text-area"
            size="small"
            aspect="outline"
            cssClass="!rounded-[4px] !h-8 !my-0"
            cssClassText="!leading-6"
            [style.pointer-events]="!hasChanges ? 'none' : null"
            [label]="TRANSLATION_KEYS.generic.CANCEL | translate"
            [disabled]="!hasChanges || saving"
            (buttonClick)="onCancel()"
          />
        </span>
        <span
          [pTooltip]="!hasChanges ? (TRANSLATION_KEYS.admin.calibrationTalentMatrix.hrComment.NO_CHANGES_TO_SAVE | translate) : ''"
          tooltipPosition="top"
        >
          <ape-button
            variant="text-area"
            size="small"
            aspect="fill"
            cssClass="!rounded-[4px] !h-8 !my-0"
            cssClassText="!leading-6"
            [style.pointer-events]="!hasChanges ? 'none' : null"
            [label]="TRANSLATION_KEYS.generic.SAVE | translate"
            [disabled]="!hasChanges"
            [isLoading]="saving"
            (buttonClick)="onSave()"
          />
        </span>
      </div>
    </ng-container>

    <!-- Commento in sola lettura -->
    <ng-template #readOnlyComment>
      <p
        *ngIf="savedText; else noComment"
        [id]="fieldId"
        class="text-gray-black text-sm leading-5 whitespace-pre-wrap wrap-anywhere"
      >{{ savedText }}</p>
      <ng-template #noComment>
        <p class="text-[#475569] text-sm leading-5">
          {{ TRANSLATION_KEYS.admin.calibrationTalentMatrix.hrComment.EMPTY | translate }}
        </p>
      </ng-template>
    </ng-template>

    <!--
      Autore e storico delle modifiche: li vede solo l'amministratore. Sezione ripiegabile, chiusa
      all'apertura: il titolo e' un pulsante (Invio e Spazio lo attivano gia', senza gestori in piu').
    -->
    <div
      *ngIf="comment?.history?.length"
      class="flex flex-col gap-3"
    >
      <button
        type="button"
        [id]="fieldId + '-history-toggle'"
        [attr.aria-expanded]="isHistoryExpanded"
        [attr.aria-controls]="isHistoryExpanded ? fieldId + '-history' : null"
        class="self-start bg-transparent border-none shadow-none cursor-pointer p-0 m-0 flex flex-row items-center gap-1"
        (click)="toggleHistory()"
      >
        <span class="text-sm font-bold text-[var(--colors-gray-scale-black)]">
          {{ TRANSLATION_KEYS.admin.calibrationTalentMatrix.hrComment.HISTORY_TITLE | translate }}
        </span>
        <svg-icon
          [src]="isHistoryExpanded ? 'assets/icons/chevron-up.svg' : 'assets/icons/chevron-down.svg'"
          aria-hidden="true"
          [svgAriaLabel]="''"
          [applyClass]="true"
          class="w-4 h-4 text-[var(--colors-gray-scale-black)]"
        />
      </button>
      <div
        *ngIf="isHistoryExpanded"
        [id]="fieldId + '-history'"
        role="region"
        [attr.aria-labelledby]="fieldId + '-history-toggle'"
        class="flex flex-col gap-3"
      >
        <div
          *ngFor="let version of comment?.history; trackBy: trackByVersion"
          class="flex flex-col gap-1 pb-3 border-b border-[var(--colors-gray-scale-gray-4)] last:border-b-0"
        >
          <div class="flex flex-row items-center gap-2">
            <ape-avatar
              [image]="version.authorAvatarUrl"
              [forename]="version.authorForename"
              [surname]="version.authorSurname"
              [size]="'normal'"
            />
            <div class="flex flex-col">
              <span class="text-black text-sm font-semibold leading-5">{{ authorDisplayName(version) }}</span>
              <span class="text-[#475569] text-xs leading-4">{{ version.modifyDate | date: "dd/MM/yyyy HH:mm" }}</span>
            </div>
          </div>
          <p
            *ngIf="version.text; else removedVersion"
            class="text-gray-black text-sm leading-5 whitespace-pre-wrap wrap-anywhere"
          >{{ version.text }}</p>
          <ng-template #removedVersion>
            <p class="text-[#475569] text-sm italic leading-5">
              {{ TRANSLATION_KEYS.admin.calibrationTalentMatrix.hrComment.REMOVED | translate }}
            </p>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-template>
</div>